
import { isFunction, camelize } from 'vessel/utils'

export default {
  name: 'VsAnimate',
  functional: true,
  props: {
    name: {
      type: String,
      default: null
    },
    duration: {
      type: [String, Number],
      default: 'faster'
    },
    delay: {
      type: [String, Number],
      default: 0
    },
    repeat: {
      type: Number,
      default: 1
    },
    infinite: {
      type: Boolean,
      default: false
    },
    appear: {
      type: Boolean,
      default: true
    },
    enter: {
      type: String,
      default: null
    },
    leave: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      default: null
    }
  },
  render(h, { data, props, children, listeners }) {
    const times = {
      slower:  3000,
      slow:    2000,
      fast:    800,
      faster:  500,
      fastest: 200
    }

    const parseTime = (value, multiplier = 1) => {
      const string = value.toString()
      const number = parseFloat(value)

      if (string.endsWith('ms')) {
        return number
      } else if (string.endsWith('s')) {
        return number * 1000
      } else {
        return number * multiplier
      }
    }

    const directionClass = (name) => {
      const klass = props[name]

      if (!props.name)
        return klass

      const state = name == 'enter' ? 'in' : 'out'
      const parts = [props.name, state, klass].filter(item => {
        return item && item.length
      })

      return camelize(parts.join('-'))
    }

    const setVariables = (el, duration, delay) => {
      el.style.setProperty('--animate-duration', `${duration}ms`)
      el.style.setProperty('--animate-delay', `${delay}ms`)
      el.style.setProperty('--animate-repeat', props.repeat)
    }

    const executeHook = (name, el) => {
      const callback = listeners[name] || listeners[camelize(name)]
      isFunction(callback) && callback(el)
    }

    const duration = parseTime(times[props.duration] || props.duration)
    const delay = parseTime(props.delay, 1000)

    const enterClass = directionClass('enter')
    const leaveClass = directionClass('leave')

    const options = {
      type:             'animation',
      appear:           props.appear,
      mode:             props.mode,
      enterClass:       null,
      enterActiveClass: null,
      enterToClass:     null,
      leaveClass:       null,
      leaveActiveClass: null,
      leaveToClass:     null
    }

    const hooks = {
      ...listeners,
      enter(el, done) {
        setVariables(el, duration, delay)
        executeHook('enter', el)

        el.classList.add('animated')
        el.classList.add(enterClass)

        if (props.infinite)
          el.classList.add('infinite')

        done()
      },
      leave(el, done) {
        el.classList.remove('infinite', enterClass)
        executeHook('leave', el)

        el.classList.add('animated')
        el.classList.add(leaveClass)

        if (!props.name && !leaveClass)
          done()

        if (!props.infinite)
          setTimeout(() => { done() }, duration + delay)
      }
    }

    return h('transition', { ...data, props: options, on: hooks }, children)
  }
}
